import cx from "classnames";
import { GlobalNav } from "common/GlobalNav";
import React from "react";
import { Link, NavLink } from "react-router-dom";
import styles from "./TwoTierNav.scss";

// This is a compatibility/migration tool for Ride Reports pages ONLY
// we need to figure out how to handle subnav in collapsed-mode
export class TwoTierNav extends React.PureComponent {
  render() {
    const { currentUser, secondaryNav } = this.props;
    return (
      <div className={styles.TwoTierNav}>
        <GlobalNav currentUser={currentUser} />
        <div className={cx(styles.secondaryNav)}>{secondaryNav}</div>
      </div>
    );
  }
}

export const NavbarLink = ({ to, ...props }) => <Link to={to} {...props} activeClassName={styles.active} />;

// this dumbness is resolved by react-router v4
export const NavbarIndexLink = ({ to, ...props }) => <NavLink to={to} {...props} activeClassName={styles.active} />;
